__turbopack_context__.v({
  "authDescription": "bondsTile-module-scss-module__wh5MyG__authDescription",
  "fallbackContainer": "bondsTile-module-scss-module__wh5MyG__fallbackContainer",
  "unAuthDescription": "bondsTile-module-scss-module__wh5MyG__unAuthDescription",
});
